// src/api/brandingApi.js
const apiUrl = process.env.REACT_APP_API_URL;

export async function fetchBranding() {
  const token =
    localStorage.getItem("auth_token") || localStorage.getItem("token");

  const res = await fetch(`${apiUrl}/companies/branding/me`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(`Branding error: ${res.status} ${t}`);
  }
  return res.json(); // { primary_color, logo_url, address, agent:{...}, ... }
}
